import React, { useEffect, useState } from 'react';
import BlogsBanner from '../Blogs/BlogsBanner/BlogsBanner';
import "./BlogDetails.scss";
import img from "../../assets/images/blog-autor-pic.png";
import Trending from '../../components/Trending/Trending';
import ContactUs from '../../components/ContactUs/ContactUs';
import { useParams } from 'react-router-dom';
import parse from 'html-react-parser';

const BlogDetails = () => {

    const { blog_slug } = useParams();
    const [blogsDetails, setBlogsDetails] = useState({});

    const data = blogsDetails?.description;

    useEffect(() => {
        fetch(`https://digitalbackend.techsistltd.com/blog_details/${blog_slug}/`)
            .then(res => res.json())
            .then(data => setBlogsDetails(data?.data))
    }, [blog_slug])

    return (
        <>
            <BlogsBanner></BlogsBanner>
            <div className="container-fluid" id='blog-details'>
                <div className="container py-5">
                    <h1 className='blog-details-title'>{blogsDetails?.title}</h1>
                    <div className="author-info-details py-3 d-flex align-items-center">
                        <img src={blogsDetails?.created_by?.image_url} alt="" className='img-fluid blog-author-img' />
                        <div className="author-txt ">
                            <p className="author-name mb-1">
                                {blogsDetails?.created_by?.name}
                            </p>
                            <p className="blog-date m-0">
                                {blogsDetails?.created_at}
                            </p>
                        </div>

                    </div>
                    <div className="blog-details-text pt-4 " >
                        {parse(`${blogsDetails?.description}`)}
                    </div>
                    {/* <div className="blog-details-text pt-4 " dangerouslySetInnerHTML={{ __html: data }}>

                    </div> */}
                    <hr className='details-blog-hr mt-3' />
                </div>
            </div>
            <Trending></Trending>
            <ContactUs></ContactUs>
        </>
    );
};

export default BlogDetails;